import dollarImage from '../../assets/images/gavel.svg';

function formatHearingDateTime(hearingDt) {
  const date = new Date(hearingDt);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const datePart = `${year}-${month}-${day}`;
  const isMidnight =
    date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0;
  if (isMidnight) {
    return datePart;
  }
  const timePart = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  })
    .format(date)
    .toLowerCase();
  return `${datePart} ${timePart}`;
}

const HearingsTab = ({ unit, openHearingWindow }) => {
  return (
    <div>
      {unit.hearings && unit.hearings.length > 0 && (
        <div className='hearing-container col-12 col-sm-12 col-md-12'>
          <div className='flex-container'>
            <div className='dollar-container sub-title'>Hearing</div>
            <div className='date-container sub-title'>Date & Time</div>
            <div className='location-container sub-title'>Location</div>
          </div>
          {unit.hearings.map((hearing) => (
            <div
              className='flex-container'
              key={`${hearing.hearingDt}-${hearing.description}`}
            >
              <div className='dollar-container'>
                <div>
                  <img alt='' aria-hidden='true' src={dollarImage} />
                  {hearing.description}
                </div>
              </div>
              <div className='date-container'>
                {hearing.hearingNotice ? (
                  <button
                    className='has-link link-button'
                    onClick={() => openHearingWindow(hearing)}
                    type='button'
                  >
                    {formatHearingDateTime(hearing.hearingDt)}
                  </button>
                ) : (
                  <span>{formatHearingDateTime(hearing.hearingDt)}</span>
                )}
              </div>
              <div className='location-container'>
                <span>{hearing.location}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HearingsTab;
